import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SnotifyService} from 'ng-snotify';
import {EmpresaService} from '../services/empresa/empresa.service';
import {MunicipioService} from '../services/Municipio/municipio.service';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {HtmlValidateDisplayHelper} from '../helpers/html-validate-display-helper';
import {LoaderService} from '../services/loader.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-cadastrar-municipio-empresa',
  templateUrl: './cadastrar-municipio-empresa.component.html',
  styleUrls: ['./cadastrar-municipio-empresa.component.scss']
})
export class CadastrarMunicipioEmpresaComponent {

    /**
     * Definições de contexto Geral
     */

    //Paramentro de URL - empresaId
    public empresaId: String;

    public empresaData: Object = {};

    public empresaMatriz: Boolean = false;

    /**
     * Definições no contexto de Empresa
     */

    public disabledSelectEmpresas: Boolean = false;

    public empresas: Array<any> = [];

    public empresaSelecionada: Array<any> = [];

    public dropdownSettingsEmpresas = {
        singleSelection: true,
        idField: 'id_empresa',
        textField: 'descricao',
        itemsShowLimit: 4,
        selectAllText: 'Marcar todas',
        unSelectAllText: 'Desmarcar todas',
        allowSearchFilter: true
    };

    /**
     * Definições no contexto de Municipio
     */

    public municipios: Array<any> = [];

    public subjectMunicipio: Subject<any> = new Subject<any>();

    public dropdownSettingsMunicipios = {
        singleSelection: false,
        idField: 'cod_mun',
        textField: 'descricao',
        itemsShowLimit: 10,
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        allowSearchFilter: true,
        noDataAvailablePlaceholderText: 'Nenhum município encontrado',
    };

    /**
     * Definições no contexto de Vinculos Municipio/Empresa
     */

    public listaMunicipiosVinculados: Array<any> = [];

    public lastResponse: any = null;

    public perPage: number = 20;

    public currentPage: number = 1;

    public loading: Boolean  = true;

    public filter: FormGroup = this.fb.group({
        municipioVinculado: new FormControl('', []),
    });

    /**
     * Definições de formulário
     */

    public submitted: Boolean = false;

    public htmlValidateDisplayHelper = new HtmlValidateDisplayHelper();

    public form: FormGroup = this.fb.group({
        empresa: new FormControl(this.empresaSelecionada, [Validators.required]),
        municipio: new FormControl('', [Validators.required]),
    });

    /**
     * Métodos de inicialização
     */

    constructor(
        private fb: FormBuilder,
        private loader: LoaderService,
        private route: ActivatedRoute,
        private router: Router,
        private notify: SnotifyService,
        private empresaService: EmpresaService,
        private municipioService: MunicipioService
    ) {
        this.router.events.subscribe((e: any) => {
            if (e instanceof NavigationEnd)
              this.initialise();
        });
    }

    public initialise() {
        this.empresaId = this.route.snapshot.paramMap.get('id')
        this.disabledSelectEmpresas = (this.empresaId == undefined) ? false : true;

        this._listarEmpresas();
        this._listarMunicipios(null);
        this._listarMunicipiosVinculados();
        this._getEmpresa();
        this.searchMunicipio()
    }

    private searchMunicipio() {
         this.subjectMunicipio.pipe(debounceTime(300),
             distinctUntilChanged()).subscribe((data) => {
             this._listarMunicipios(data);
         });
  }

    /**
     * Métodos de interação
     */
    private _getEmpresa(): void  {
        this.loader.show();

        this.empresaService.visualizar({'id': this.empresaId}).subscribe(
            ({data}) => {
                this.loader.hide();
                const selectedItem = [];

                this.empresaData = data;
                this.empresaMatriz = this.empresaData['filial'] == 'MATRIZ' ? true : false;

                if (this.empresaData['filial'] == 'MATRIZ') {
                    if (this.empresaId != undefined && data.id_empresa == this.empresaId)
                        selectedItem.push({descricao: data.apelido, id_empresa: data.id_empresa});
                } else {
                    selectedItem.push({descricao: data.apelido, id_empresa: data.filial});
                }

                this.form.controls['empresa'].setValue(selectedItem);
            },
            error => {
                this.loader.hide();
                this.notify.warning('Ocorreu um erro ao carregar os da empresa');
            }
        );
    }

    private _listarEmpresas(): void  {
        this.empresaService.listarMatriz().subscribe(
            ({data}) => {
                const flags = [], output = [] ;

                for (let i = 0; i < data.length; i++) {
                    if (flags[data[i].apelido])
                        continue;

                    flags[data[i].apelido] = true;

                    if (data[i].apelido != null)
                        output.push({descricao: data[i].apelido, id_empresa: data[i].id_empresa});
                }

                this.empresas = output;

            },
            error => {
                this.notify.warning('Ocorreu um erro ao carregar as empresas');
            }
        );
    }

    private _listarMunicipios(filtro): void {
        this.municipioService.listarMuncipiosEmpresas(filtro).subscribe(
            ({data}) => {
                const flags = [], output = [];

                for (let i = 0; i < data.municipio.data.length; i++) {
                    if (data.municipio.data[i].nome != null)
                        output.push({descricao: data.municipio.data[i].nome + ' - ' + data.municipio.data[i].estado.uf, cod_mun: data.municipio.data[i].id_municipio});
                }

                this.municipios = output;
            },
            error => {
                this.notify.error('Ocorreu um erro ao carregar os municípios');
            }
        );
    }

    private _listarMunicipiosVinculados(): void {
        this.loading = true;

        this.empresaService.listaMunicipiosMapeados(this.getFilters(), this.currentPage, this.perPage).subscribe(
            ({data}: any) => {
                this.loading = false;
                this.lastResponse = data;
                this.listaMunicipiosVinculados = this.listaMunicipiosVinculados.concat(this.lastResponse.municipios.data);
            },
            error => {
                this.loading = false;
                this.notify.error('Ocorreu um erro ao carregar os municípios vinculados');
            }
        );
    }

    public adicionar(): void {
        this.loader.show();
        this.submitted = true;

        if (!this.form.invalid) {

            const filter = {};

            Object.keys(this.form.controls).forEach((_filter) => {
                filter[_filter] = this.form.controls[_filter].value;
            });

            this.municipioService.inserirMunicipiosEmpresa(filter).subscribe(
                (data) => {
                    this.submitted = false;
                    this.loader.hide();
                    this.reset(true);
                    this._listarMunicipiosVinculados();
                    this.notify.success(data.message);
                },
                error => {
                    this.submitted = false;
                    this.loader.hide();
                    this.notify.error('Ocorreu um erro ao salvar os dados');
                }
            );

        } else {
            this.loader.hide();
            this.notify.error('Seu formulário apresenta dados inconsistentes');
        }
    }

    public removerVinculo(empresa: String, id_municipio: Number): void {
        if (confirm('Você confirma a remoção deste município?')) {
            this.loader.show();

            this.municipioService.removeMunicipiosMapeados(empresa, id_municipio).subscribe(
                ({data}: any) => {
                    this.loader.hide();
                    this.reset(true);
                    this.notify.success('Vinculo com o município removido com sucesso');
                },
                error => {
                    this.loader.hide();
                    this.notify.error('Ocorreu um erro ao remover o município vinculado');
                }
            );
        }
    }

    public toFilter(): void {
        this.reset(false);
        this._listarMunicipiosVinculados();
    }

    public reset(reload: boolean): void {
        this.listaMunicipiosVinculados = [];
        this.currentPage = 1;

        if(reload) {
          Object.keys(this.filter.controls).forEach(key => {
            this.filter.controls[key].setValue(null);
          });

          this.form.controls['municipio'].setValue('');
          this.form.controls['municipio'].setErrors(null);

          this._listarMunicipiosVinculados()   ;
        }
    }

    public getFilters(): Object {
        const filter = {};

        Object.keys(this.filter.controls).forEach((_filter) => {
          filter[_filter] = this.filter.controls[_filter].value;
        });

        if (this.empresaId != undefined)
            filter['empresa'] = this.empresaId;

        return filter;
    }

    public loadMore(): void {
        this.currentPage++;
        this._listarMunicipiosVinculados();
    }

    public loadPerPage($event: any): void {
        this.perPage = $event.target.value;
        this.reset(false);
        this._listarMunicipiosVinculados();
    }
}
